import { SelectDeviceLog } from "../../../features/SelectDeviceLog";
import LogMessages from "../../../shared/ui/LogMessages";
import InfoBar from "../../../shared/ui/InfoBar/InfoBar";
import "./LogListWidget.scss";

const LogListWidget = () => {
  return (
    <div className="log-list">
      <SelectDeviceLog />
      <InfoBar />
      <LogMessages />
    </div>
  );
};

export default LogListWidget;
